/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Distribute_Point_3Inputs */

const en_landing_step_distribute_point_3 = /** @type {(inputs: Landing_Step_Distribute_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every client touchpoint stays human-led`)
};

/**
* | output |
* | --- |
* | "Every client touchpoint stays human-led" |
*
* @param {Landing_Step_Distribute_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_distribute_point_3 = /** @type {((inputs?: Landing_Step_Distribute_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Distribute_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_distribute_point_3(inputs)
});